import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push, replace } from 'react-router-redux'

import LoginForm from '../components/LoginForm/LoginForm.js'
import Button from '../components/Button/Button.js'
import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'


const getUrlParams = () => {
  var urlParams;
  var match,
      pl     = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
      query  = window.location.search.substring(1);

  urlParams = {};
  while (match = search.exec(query))
     urlParams[decode(match[1])] = decode(match[2]);

  return urlParams;
}

class Login extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount(){
    const { dispatch, user } = this.props;
    
    if(user.isLoggedIn){
      var urlParams = getUrlParams();
      if(urlParams.after){
        dispatch(replace(window.atob(urlParams.after)));
      } else {
        dispatch(replace('/'));
      }
    } 
  }

  componentDidMount(){
    window.document.title = "Log In - Pattycake";

    // const { dispatch, user} = this.props;

    // if(user.isLoggedIn){
    //   dispatch(push('/'));
    // }
  }


  render(){

    const { user } = this.props;

    return <div className="body-stretch">
      <Header transparent={true}/>
      <div className="stretched">
        <div className="container">
          <div className="row justify-content-center row-mega-padded">
            <div className="col-md-4">
              <h1 className="text-center">
                Welcome back.
              </h1>
              <p className="lead text-center p-push-down">We missed you.</p>
              <LoginForm/>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/routes/Login.js